<template>

  <div class="vflex">
            
    <div class="vflex-row-0">
  
      <ul
        class="nav nav-tabs"
        id="myTab"
        role="tablist">
        <li class="nav-item ml-3">
          <router-link
            class="nav-link"
            :class="{'active': emailType === 'received'}"
            :to="{path: '/email'}">{{ $t('Received') }}</router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{'active': emailType === 'sent'}"
            :to="{path: '/email/sent'}">{{ $t('Sent') }}</router-link>
        </li>
      </ul>

    </div>
    <div class="vflex-row-0 vflex-header">
  
      <div class="d-flex">
        <div class="flex-grow-1">
          <input-keyword
            :value="$route.query.text"
            @input="setKeyword"
            :placeholder="$t('Find email')"
            style="border: 0" />  
        </div>
        <div v-if="emailType === 'received'">
          <select
            class="form-control"
            @input="setReadType">
            <option :value="undefined">{{ $t('All') }}</option>
            <option :value="true">Lidos</option>
            <option :value="false">Não lidos</option>
          </select>    
        </div>
      </div>

    </div>
    <div class="vflex-row-1">
    
      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="setPage">
        
        <template slot="content">
          <div class="list-group list-group-flush">
            <email-list-item
              v-for="(email, index) in emails"
              :key="index"
              :email="email"></email-list-item>
          </div>
        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>

    </div>

  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import Paginaty from '@/components/Paginaty/Paginaty'
import EmailListItem from './EmailListItem'
import KeywordSearchSanitize from '@/utils/KeywordSearchSanitize'

export default {
  name: 'EmailList',
  components: {
    InputKeyword,
    Paginaty,
    EmailListItem
  },
  data () {
    return {
      creating: true,
      loading: true
    }
  },
  computed: {
    emails () {
      return this.$store.getters.getEmails
    },
    paginate () {
      return this.$store.getters.getEmailsPaginate
    },
    emailType () {
      return this.$route.params.type || 'received'
    },
    filters () {
      return {
        text: this.$route.query.text ? KeywordSearchSanitize(this.$route.query.text) : undefined,
        read: this.$route.query.read ? this.$route.query.read : undefined
      }
    }
  },
  watch: {
    emailType (val) {
      this.creating = true
      this.setPage()
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        type: this.emailType,
        page: this.$route.query.page,
        sort: '-created_at',
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectEmails', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.setPage(1)
        this.pages = result.pages
        this.loading = this.creating = false
      })
    },
    /*
    setKeyword
    */
    setKeyword (keywords) {
      this.$changeUrlParam({text: keywords || undefined})
      this.setPage(1)
    },
    setReadType (event) {
      this.$changeUrlParam({read: event.target.value})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.active {
  background: #cce5ff;
  border-color: #cce5ff;
}
</style>



// WEBPACK FOOTER //
// src/components/Email/EmailList.vue